<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="funnel-icon"
  >
    <g>
      <path
        d="M2.66 3.75C2.66 3.75 2.66 3.75 2.66 3.75L17.34 3.75C17.34 3.75 17.34 3.75 17.34 3.75"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.67 17.58C14.67 17.58 14.67 17.58 14.67 17.58L5.33 17.58C5.33 17.58 5.33 17.58 5.33 17.58"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>

<script setup>
// Funnel icon component
</script>

<style scoped>
.funnel-icon {
  color: inherit;
}
</style>